import { buryPoint } from '@/Common/plugins/buried-point';

export default {
  openEventCenter() {
    buryPoint.event({
      action: '浏览事件中心模块-使用模块',
      eventCategory: '浏览事件中心模块'
    });
  },
  enterEventCenterPosition(pos) {
    const op = {
      1: '顶部导航栏消息下拉查看全部',
      2: 'Home页异常事件概览-查看全部异常事件',
      3: 'Home页异常事件概览-查看某类异常事件',
      4: 'Home页常用操作-查看异常事件',
      5: '左侧导航栏'
    };
    buryPoint.event({
      action: '浏览事件中心模块-入口位置',
      eventCategory: '浏览事件中心模块',
      eventLabel: op[pos]
    });
  },
  stayEventCenterTime(time, eventLabel) {
    buryPoint.timing({
      name: '浏览事件中心模块-使用时长',
      time,
      eventCategory: '浏览事件中心模块',
      eventLabel
    });
  },
  clearEventPromtList() {
    buryPoint.event({
      action: '清空通知栏消息-使用功能',
      eventCategory: '清空通知栏消息'
    });
  },
  eventCenterSearchEventByChannel() {
    buryPoint.event({
      action: '站点/设备/通路检索-使用功能',
      eventCategory: '站点/设备/通路检索'
    });
  },
  eventCenterSearchEventByTime() {
    buryPoint.event({
      action: '事件时间筛选-使用功能',
      eventCategory: '事件时间筛选'
    });
  },
  eventCenterSearchEventByTimeOption(option) {
    const op = {
      1: '今天',
      2: '近7天',
      3: '自定义',
      4: '所有'
    };
    buryPoint.event({
      action: '事件时间筛选-时间类型',
      eventCategory: '事件时间筛选',
      eventLabel: op[option]
    });
  },
  eventCenterSearchEventByEventType() {
    buryPoint.event({
      action: '异常事件类型筛选-使用功能',
      eventCategory: '异常事件类型筛选'
    });
  },
  exportExceptionReport (flag) {
    const op = {
      0: 'Excel',
      1: 'csv',
      2: 'pdf'
    };
    buryPoint.event({
      action: '异常事件导出-使用功能',
      eventCategory: '异常事件导出',
      eventLabel: op[flag]
    });
  },
  enableAutoRefresh () {
    buryPoint.event({
      action: '开启自动更新-使用功能',
      eventCategory: '开启自动更新'
    });
  },
  disableAutoRefresh () {
    buryPoint.event({
      action: '关闭自动更新-使用功能',
      eventCategory: '关闭自动更新'
    });
  },
  openNewTag () {
    buryPoint.event({
      action: '新标签页打开-使用功能',
      eventCategory: '新标签页打开'
    });
  }
};
